<template>
  <b-form
    ref="overrideForm"
    novalidate
    :validated="validated">
    <b-form-group
      label="Override Date Range"
      :disabled="!canWebviewEdit"
      class="mt-4">
      <v-date-picker
        v-model="dates"
        :disabled-dates="disabledDates"
        mode="range"
        is-required>
        <b-form-input
          slot-scope="{ inputProps, inputEvents }"
          v-bind="inputProps"
          type="text"
          required
          v-on="inputEvents" />
      </v-date-picker>
    </b-form-group>
    <web-view-form
      ref="configForm"
      v-model="override" />
    <div class="d-flex justify-content-between mt-4">
      <template v-if="canWebviewEdit">
        <b-btn
          variant="search"
          class="xl-wide"
          @click.prevent="onCancel">
          Cancel
        </b-btn>
        <b-btn
          variant="primary"
          class="xl-wide"
          @click.prevent="onSave">
          Save
        </b-btn>
      </template>
      <b-btn
        v-else
        variant="search"
        class="xl-wide"
        @click.prevent="onCancel">
        Close
      </b-btn>
    </div>
  </b-form>
</template>

<script>
  import VDatePicker from 'v-calendar/lib/components/date-picker.umd'
  import WebViewForm from "@/components/WebView/WebViewForm"
  import webview from "@/services/webview"
  import _ from "lodash"
  import {mapGetters} from "vuex"

  export default {
    name: "WebViewOverrideForm",
    components: {
      WebViewForm,
      VDatePicker,
    },
    props: {
      startDate: {
        type: Date,
        default: null,
      },
      endDate: {
        type: Date,
        default: null,
      },
      config: {
        type: Object,
        default: () => ({
          ...webview.newConfig(),
        }),
      },
      disabledDates: {
        type: Array,
        default: () => [],
      },
    },
    data: () => ({
      validated: false,
      dates: {
        start: null,
        end: null,
      },
      override: {
        ...webview.newConfig(),
      },
    }),
    computed: {
      ...mapGetters([
        "canWebviewEdit",
      ]),
    },
    created() {
      this.override = _.cloneDeep(this.config)
      this.dates = {
        start: this.startDate,
        end: this.endDate,
      }
    },
    methods: {
      onSave() {
        this.validated = true
        const hasError = !(this.$refs.overrideForm.checkValidity() && this.$refs.configForm.isValid())
        if (hasError) {
          this.$alert.warning("Override contains one or more errors. Please fix these errors before saving.")
          return
        }

        this.$emit("save", this.dates.start, this.dates.end, this.override)
      },
      onCancel() {
        this.$emit("cancel")
      },
    },
  }
</script>

<style scoped>

</style>
